import { MRT_ColumnDef } from 'material-react-table';
import { useTranslation } from 'react-i18next';

export type EndUsersColumns = {
    email: string;
    createdAt: string;
};

export const useEndUsersTableColumns = (): MRT_ColumnDef<EndUsersColumns>[] => {
    const { t } = useTranslation();

    return [
        {
            accessorKey: 'fullName',
            header: t('TABLE_HEADERS.FULL_NAME'),
            size: 200,
            enableSorting: false,
            enableColumnActions: false,
        },
        {
            accessorKey: 'email',
            header: t('TABLE_HEADERS.EMAIL'),
            size: 250,
            enableColumnActions: false,
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            accessorKey: 'phoneNumber',
            header: t('TABLE_HEADERS.PHONE'),
            size: 150,
            enableColumnActions: false,
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            accessorKey: 'createdAt',
            header: t('TABLE_HEADERS.CREATION_DATE'),
            size: 100,
            enableColumnActions: false,
            enableColumnFilter: false,
        },
    ];
};
